export function addPersistedQueries(link, persistedQueries) {
    link.persistedQueries = persistedQueries;
}
